<template>
	<AppDialog height="655" dialogName="Onboarding text" width="620">
		<OnboardingFeatureDescriptionDialogContent @close="close" :workflowId="editWorkflow.id" />
	</AppDialog>
</template>

<script>
import AppDialog from '../AppDialog/AppDialog.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import OnboardingFeatureDescriptionDialogContent from '@/components/dialogs/OnboardingTextEditorDialog/OnboardingFeatureDescriptionDialogContent.vue';
export default {
	name: 'OnboardingTextEditorDialog',
	components: { AppDialog, OnboardingFeatureDescriptionDialogContent },
	props: { dialogPromiseHandlers: { type: Object } },
	computed: { ...mapGettersShorthand({ editWorkflow }) },
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>
<style scoped lang="scss"></style>
